import { render, staticRenderFns } from "./PageDeck.vue?vue&type=template&id=9816b166&scoped=true"
import script from "./PageDeck.vue?vue&type=script&lang=js"
export * from "./PageDeck.vue?vue&type=script&lang=js"
import style0 from "./PageDeck.vue?vue&type=style&index=0&id=9816b166&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9816b166",
  null
  
)

export default component.exports